var Header = {
	currentScroll : 0,
	init:function(){
		$(window).scroll(function(){
			Header.scroll();
		});

		Header.scroll();

		$(window).resize(function(){
			Header.resize();
		});

		Header.resize();

		if($(".header .mini-nav-mobile").find(".current-menu-item").length == 0 && $(".header .mini-nav-mobile").find(".current-menu-ancestor").length){
			$(".header .mini-nav-mobile").addClass("no-current-menu-item");
		}

		$(".header .mini-nav-mobile").on("click touchend", function(e) {
			if (e.type == 'touchend') {
				$(this).off("click");
			}
			var _this = $(this);
			setTimeout(function(){
				_this.toggleClass("open");
			}, 100);
		});


		$(".header .btn-mobile").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}

			$(this).toggleClass("open");			
			$(".header .left").find(".nav-main").toggleClass("open");

		});
		
		if(!$("body").hasClass("home")){
				$(".header .div-middle").find(".logo-desktop").addClass("visible");				
			}
		
	},
	close_submenu:function(){
		$(this).removeClass("open");			
		$(".header .left").find(".nav-main").removeClass("open");
	},
	resize:function(){
		Header.close_submenu();
	},
	scroll:function(){

		if($(window).scrollTop() < 40){
			Header.open_header();
		}else{
			if($(window).scrollTop() > Header.currentScroll){
				Header.close_header();
			}else{
				Header.open_header();
			}
		}

		Header.currentScroll = $(window).scrollTop();

	},
	open_header:function(){
		$(".header").removeClass("closed");

		if($(window).scrollTop() > 40){
			$(".header .div-middle").find(".logo-desktop").addClass("visible");
			$(".header").addClass("shadow-sticky");
		}else{
			if($("body").hasClass("home")){
				$(".header .div-middle").find(".logo-desktop").removeClass("visible");				
			}
			$(".header").removeClass("shadow-sticky");
		}

	},
	close_header:function(){

		if(!$(".header").hasClass("open")){

			$(".header").addClass("closed");
			Header.close_submenu();
		}
	}
}

$(window).load(function(){
	if($(".header").length){
		Header.init();
	}
})